/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\variable.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */


export const ADD_VARIABLE = 'ADD_VARIABLE_';
export const REMOVE_VARIABLE = 'REMOVE_VARIABLE_';

export function createVariable(id) {
  return {
    type: ADD_VARIABLE,
    id,
  };
}

export function removeVariable(id) {
  return {
    type: REMOVE_VARIABLE,
    id,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/variable.js